import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private encryptSecretKey: string = 'TWREPO_ENC_KEY_190022XEW11FH';
  constructor() { }
  decryptAES(data: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return bytes.toString(CryptoJS.enc.Utf8);
      }
      return data;
    } catch (e) { }

    return data;
  }

  public encryptAES(decString: string): string {
    return CryptoJS.AES.encrypt(decString, this.encryptSecretKey).toString();
  }

  encryptAesWithIVY(message: string): string {
    var key = CryptoJS.enc.Utf8.parse('WiuFbsPnSsOJaElq'); // this shouldn't be changed because api code uses same keys
    var iv = CryptoJS.enc.Utf8.parse('MACMZvQpiSYdcWGd'); // this shouldn't be changed because api code uses same keys
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(message), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return  encrypted.toString();
  }
}
